import { useEffect } from "react";

export type FyaiSeoInput = {
  title: string;
  keywords?: string;
  description?: string;
  /** 页面路径，例如 "/" 或 "/download"；不传则不更新 canonical */
  path?: string;
};

const SITE_ORIGIN = "https://www.fengyueaiapp.net";

function upsertMeta(attr: "name" | "property", key: string, content?: string) {
  const selector = `meta[${attr}="${key}"]`;
  const existing = document.head.querySelector<HTMLMetaElement>(selector);
  if (!content) {
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    return;
  }
  const el = existing ?? document.createElement("meta");
  if (!existing) {
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(url: string) {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

/**
 * 为 SPA 的每个路由设置独立的 SEO 信息（标题 / 关键词 / 描述 / canonical / 社交分享标签）。
 */
export function useFyaiSeo({ title, keywords, description, path }: FyaiSeoInput) {
  useEffect(() => {
    document.title = title;

    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "description", description);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    if (path !== undefined) {
      const url = `${SITE_ORIGIN}${path === "/" ? "/" : path}`;
      upsertCanonical(url);
      upsertMeta("property", "og:url", url);
    }
  }, [title, keywords, description, path]);
}